/**
 * @file CrmDialogSurface.tsx
 * @description Оболочка коротких форм зоны «Клиенты и сделки» (phase19.31,
 * SC61): окно на широком экране, нижняя шторка на телефоне — одно
 * содержимое. Вынесено из формы событий сделки, чтобы окно причины переноса
 * и форма событий выглядели одинаково.
 */

import type { ReactNode } from "react";

import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "../ui/sheet";
import { PHONE_QUERY, useMediaQuery } from "../../hooks/useMediaQuery";

interface Props {
  title: string;
  onClose: () => void;
  children: ReactNode;
}

export function CrmDialogSurface({ title, onClose, children }: Props) {
  const phone = useMediaQuery(PHONE_QUERY);
  if (phone) {
    return (
      <Sheet open onOpenChange={(open) => !open && onClose()}>
        <SheetContent side="bottom" className="max-h-[90dvh] overflow-y-auto pb-[calc(1.5rem+env(safe-area-inset-bottom))]">
          <SheetHeader>
            <SheetTitle className="type-card-title">{title}</SheetTitle>
          </SheetHeader>
          {children}
        </SheetContent>
      </Sheet>
    );
  }
  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        {children}
      </DialogContent>
    </Dialog>
  );
}
